import { LessonPlanStepStatus } from '../../_models/lesson-plan-step-status';
import { User } from '../../_models/user';
// import { ApiService, AttendanceService, AuthenticationService, DialogService, LessonPlanService } from '../../_services';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import AuthenticationService from '../../_services/AuthenticationService';
import ApiService from '../../_services/ApiService';
import AttendanceService from '../../_services/AttendanceService';
import Config from '../../_config/config';
import LessonPlanService from '../../_services/LessonPlanService';
import DialogService from '../../_services/DialogService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { AlertDialog } from '../../_components/alert-dialog/AlertDialog';
// import DbService from '../../_services/DbService';

interface Myprops extends RouteComponentProps{

}
interface Mystate 
{
  showAlert:boolean,
  alertMessage: string,
  loadingProgress: number
  loadingText: string
}
export class SyncOut extends React.Component<Myprops,Mystate> {

    state:Mystate = {
      showAlert:false,
      alertMessage:'',
      loadingProgress: 0,
      loadingText:''
    }

  currentUser: User; 
  lessonplanservice:LessonPlanService = new LessonPlanService()
  // dbservice:DbService = new DbService()



  syncoutDate: any = null;
  constructor(
    props) {
      super(props)
      this.currentUser = AuthenticationService.currentUserValue;
      this._dismiss = this._dismiss.bind(this)
   }

  componentDidMount(): void {
    this.initSyncOut();
  }

  initSyncOut(): void {
        AttendanceService.getScheduleActivitySlotsBySyncStatus(0).then(data => {
            console.log("Attendance JSON :"+JSON.stringify(data));
            if(data.length > 0) {
              this.syncOutAttendanceActivitySlotWise(data, 0);
            }else{
              console.log("syncoutlessonplanstatus")
              this.syncOutLessonplanStatus();
            }
          });   
  }

  syncOutAttendanceActivitySlotWise(activitySlots:any, index:number) {
    console.log("In syncOutAttendanceActivitySlotWise...");
    this.setState({loadingProgress : this.state.loadingProgress+Math.round(40/activitySlots.length)});
    this.setState({loadingText : "Synchronizing Attendance for Class "+(index+1)+"/"+activitySlots.length+" ..."});
    let syncOutAttendanceData: any = activitySlots[index];
    let _attendanceDetails: any = [];
    activitySlots[index].studentAttendanceDetails.forEach(attendanceDetail => {
      let studentAttendanceDetail: any = {
        enrollmentId: attendanceDetail.student.id,
        attendanceStatusId: attendanceDetail.attendanceStatus==true?1:2 //1= Present; 2= Absent
      };
      _attendanceDetails.push(studentAttendanceDetail);
    });
    syncOutAttendanceData.attendanceDetails = _attendanceDetails;
    syncOutAttendanceData.submittedBy = this.currentUser.instructorId;
    syncOutAttendanceData.classStatus=1;
    console.log("SYNC OUT Data : "+JSON.stringify(syncOutAttendanceData));
    ApiService.syncOutAttendnace(syncOutAttendanceData)
    .then(
      res => {
          const respData = res.data
        console.log("Resp Data : "+JSON.stringify(respData));
        if(respData.status==0) {  //Error Occurred while saving Attendance
          //this.showProgress=false;
          index++;
            // DialogService.alert()
            this.showAlertDialog('Attendance sync-out Error:'+ respData.message)
            if(index<activitySlots.length){
              this.syncOutAttendanceActivitySlotWise(activitySlots, index);  
            }
            else {
              //this.syncSuccess();
              console.log("syncoutlessonplanstatus")
              this.syncOutLessonplanStatus();
            }
        }
        else { // Attendance saved successfully
              this.syncoutDate = respData.data.syncOutDate;
              activitySlots[index].syncStatus = 1;
              AttendanceService.updateAttendance(activitySlots[index]).then(data => {              
                    index++;            
                    if(index<activitySlots.length){
                      this.syncOutAttendanceActivitySlotWise(activitySlots, index);  
                    } else {
                      this.syncOutLessonplanStatus();
                    }
              },
              error => {
                this.showAlertDialog('Attendance update Error:'+ error); 
                console.log('Attendance update Error:'+ error);
              });
         
        }
      },
      error => {
        //this.alertService.error(error);
        console.log(error);
        this.connectionError(); 
      }
    );    
  }

  syncOutLessonplanStatus() {
    console.log("In syncOutLessonplanStatus...");
    this.setState({loadingProgress : 60});
    this.setState({loadingText : "Synchronizing Lessonplan status... "});
    this.lessonplanservice.getLessonPlanStepStatusesBySyncStatus(0).then(lpsdata => {
      if(lpsdata.length > 0) {
        let lessonplanData:any = {submittedBy:this.currentUser.instructorId, lessonplanStatus:lpsdata} ;
        ApiService.syncOutLessonplanStatus(lessonplanData)
          .then(
            res => {
                const respData = res.data
              console.log("Resp Data : "+JSON.stringify(respData));
              if(respData.status==0) {  //Error Occurred while saving Lessonplan status
                this.setState({alertMessage:'Attendance sync-out Error:'+ respData.message,showAlert:true})
                // this.showAlertDialog('Lessonplan status sync-out Error:'+ respData.message);
              }
              else { // Lessonplan status saved successfully
                this.syncoutDate = respData.data.syncOutDate;
                let lessonPlanStepStatusDetails : LessonPlanStepStatus[] = []; 
                lpsdata.forEach(lessonPlanStepStatus => {
                  let lessonPlanStepStatusDetail : LessonPlanStepStatus = lessonPlanStepStatus;
                  lessonPlanStepStatusDetail.syncStatus =1;
                  lessonPlanStepStatusDetails.push(lessonPlanStepStatusDetail);
                });
                    this.lessonplanservice.addLessonPlanStepStatuses(lessonPlanStepStatusDetails).then(data => {              
                  console.log("Lessonplan status update success..");
                  this.syncSuccess();
                },
                error => {
                  this.showAlertDialog('Lessonplan status update Error:'+ error); 
                  console.log('Lessonplan status update Error:'+ error);
                });
              }
            },
            error => {
              console.log(error);
              this.connectionError(); 
            }
          );
      }
      else {
        this.syncSuccess();  
      }
    });
  }

  syncSuccess() {
    localStorage.setItem("lastSyncOutDate", this.syncoutDate);
    this.setState({loadingProgress : 100});
    this.setState({loadingText : "Synchronizing Done Successfully."});
    setTimeout(() => { 
      this._dismiss();     
    }, 3000); 
  }

  public showAlertDialog(message: string) {
      this.setState({showAlert:true ,alertMessage:message})
        // DialogService.alert(message)
    // .then((confirmed) => console.log('User confirmed:', confirmed))
    // .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  public connectionError() {
    //public CONNECTION_ERROR_MSG:string ="The server is taking too long to respond OR something is wrong with your internet connection. Please try again later." 
    this.setState({showAlert:true ,alertMessage:Config.CONNECTION_ERROR_MSG})
    // .then((confirmed) => console.log('User confirmed:', confirmed))
    // .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }
  public handleAlert(flag){
    // this.props.history.goBack()
  }
  public _dismiss() {
    console.log("in dismiss")
    this.props.history.goBack();  
  }

  render() {
      return(
        <div className="sync-out">
        {this.state.showAlert && <AlertDialog message={this.state.alertMessage} title="Alert" btnOkText="OK" size="sm" close={this.handleAlert}/> }
        <div className="app flex-row align-items-center">
        <div className="container">
            <div className="card-group">
                <div className="card text-center border-info full-height1">
                    <div className="card-header pageheading bg-info text-white">
                        <FontAwesomeIcon 
                            icon={faArrowLeft}
                            size="lg" 
                            className="float-left"
                            onClick={() => this._dismiss()}
                        ></FontAwesomeIcon>
                        <b>Sync-Out</b>
                    </div>
                    <div className="card-body">
                        <div>{this.state.loadingText}</div>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar"
                                // attr.aria-valuenow="loadingProgress" 
                                aria-valuemin={0}
                                aria-valuemax={100}
                                style={{width:`${this.state.loadingProgress}%`}}
                            >
                                {this.state.loadingProgress}%
                            </div>
                        </div>
                    </div>               
                </div>
            </div>
        </div>
    </div> 
    </div>              
    
    
      )
  }

}
